module.exports = __webpack_public_path__ + "img/IMG_9035.345a3d66.jpg";